import React from "react";
import "../sass/main.scss";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="row">
          <div className="col-1-of-6">
            Anne
            <div>
              <a
                href="https://www.linkedin.com/in/anne-marie-porter-laporte-9a94a4159/"
                target="blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-1-of-6">
            Ayo
            <div>
              <a
                href="https://www.linkedin.com/in/ayobami-adelugba-975450a4/"
                target="blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-1-of-6">
            Claudia
            <div>
              <a
                href="https://www.linkedin.com/in/claudiaerojas/"
                target="blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-1-of-6">
            Khai
            <div>
              <a href="https://www.linkedin.com/in/khaifahmi/" target="blank">
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-1-of-6">
            Maria
            <div>
              <a
                href="https://www.linkedin.com/in/mariabeckles/"
                target="blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="venu col-1-of-6">
            Venu
            <div>
              <a href="https://www.linkedin.com/in/svenus" target="blank">
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
